import { Reveal } from "./motion";

const STEPS = [
  { time: "8:30–9:00", title: "coffee & connect.", body: "catch up and meet any new faces." },
  { time: "9:00–9:15", title: "guidance.", body: "we settle in and set the focus for the hour. a prompt if you need one." },
  { time: "9:15–10:15", title: "the work hour.", body: "everyone moves their own project forward." },
  { time: "10:15–10:30", title: "wrap & share.", body: "we close the community time, share where we need support, and ask any questions before we head out." },
];

export const Timeline = () => (
  <section id="morning" data-testid="timeline" className="bg-oat px-5 sm:px-8 lg:px-12 py-24 sm:py-32">
    <div className="max-w-[1100px] mx-auto">
      <Reveal>
        <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.24em] text-mushroom-deep">
          how a morning goes
        </span>
        <h2 className="mt-4 font-display font-black lowercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl">
          two hours, one clear rhythm
        </h2>
      </Reveal>

      <div className="mt-14 border-t border-ink/15">
        {STEPS.map((s, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <div className="group grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-6 items-baseline py-7 border-b border-ink/15 transition-colors hover:bg-butter/40 -mx-4 px-4 rounded-lg">
              <div className="sm:col-span-3 font-display font-black text-xl sm:text-2xl tabular-nums text-ink">
                {s.time}
              </div>
              <div className="sm:col-span-9">
                <span className="font-semibold text-lg sm:text-2xl text-ink">{s.title} </span>
                <span className="text-lg sm:text-2xl font-medium text-ink/70 leading-[1.2]">{s.body}</span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-10 text-base sm:text-lg font-medium leading-[1.3] text-ink/70 max-w-2xl">
          come and go as your day allows. you can join for any part of the morning, arrive late,
          or leave early. however you can be here, you're welcome.
        </p>
      </Reveal>
    </div>
  </section>
);
